/* eslint-disable react/no-array-index-key */
// @flow
import React, { type Node } from 'react';
import Autosuggest from 'react-autosuggest';
import matchHighlights from 'autosuggest-highlight/match';
import parseHighlights from 'autosuggest-highlight/parse';

const getSuggestionValue = suggestion => suggestion.displayText;

const renderSuggestion = (suggestion, { query }) => {
  const matches = matchHighlights(suggestion.displayText, query);
  const parts = parseHighlights(suggestion.displayText, matches);

  return (
    <span>
      {
        parts.map((part, index) => (
          <span className={part.highlight ? 'highlight' : null} key={index}>{part.text}</span>
        ))
      }
    </span>
  );
};

type State = {
    value: string,
  };


class CategoryFilter extends React.Component<*, State> {
  constructor() {
    super();

    this.state = {
      value: '',
    };
  }

  state: State;


  onChange: ((event: any, any) => void) = (event: Object, { newValue }: Object) => {
    this.setState({
      value: newValue,
    });
  };


  onSuggestionsFetchRequested: ((any) => void) = ({ value }: Object) => {
    const { onCategorySearch } = this.props;
    onCategorySearch(value);
  };

  onSuggestionsClearRequested: (() => void) = () => {};

  addCategory: ((event: any, any) => void) = (event: Object, { suggestion } : Object) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
    this.props.selectSuggestion(suggestion);
    this.setState({
      value: '',
    });
  }


  props: {
    placeholder: string,
    categories: Object,
    selectSuggestion: Function,
    onCategorySearch: Function,
    disabled: boolean,
  }


  render(): Node {
    const { value } = this.state;
    const { categories, placeholder, disabled } = this.props;
    const suggestions = value.trim().length === 0 ? [] : categories;

    const inputProps = {
      placeholder,
      value,
      onChange: this.onChange,
      disabled,
    };

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={this.addCategory}
        inputProps={inputProps}
        alwaysRenderSuggestions
        highlightFirstSuggestion
      />
    );
  }
}

export default(CategoryFilter);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/CategoryFilter.js